<script lang="ts">
  let props = $props()
  let { score } = props

  import { ShieldAlert, ShieldCheck, ShieldX, Medal } from "lucide-svelte"
</script>

{#if score < 39}
  <p
    class="mt-1 text-sm sm:text-base lg:text-xl/5 text-gray-800 text-right md:text-left flex justify-end md:justify-start items-center font-bold"
  >
    <ShieldX class="size-4 sm:size-6 text-red-600 mr-1" /> Misaligned
  </p>
{:else if score >= 40 && score < 80}
  <p
    class="mt-1 text-sm sm:text-base lg:text-xl/5 text-gray-800 text-right md:text-left flex justify-end md:justify-start items-center font-bold"
  >
    <ShieldAlert class="size-4 sm:size-6 text-amber-600 mr-1" /> Mixed Signals
  </p>
{:else if score >= 80 && score <= 99}
  <p
    class="mt-1 text-sm sm:text-base lg:text-xl/5 text-gray-800 text-right md:text-left flex justify-end md:justify-start items-center font-bold"
  >
    <ShieldCheck class="size-4 sm:size-6 text-emerald-600 mr-1" /> On Track
  </p>
{:else if score == 100}
  <p
    class="mt-1 text-sm sm:text-base lg:text-xl/5 text-gray-800 text-right md:text-left flex justify-end md:justify-start items-center font-bold"
  >
    <Medal class="size-4 sm:size-6 text-green-600 mr-1" /> Ideal
  </p>
{/if}
